// CLIENT-RECORD-SPEC §3.1 kind vocabulary (David, 2026-09-16): kind is the
// AGENCY's view. A retained client is a Renewal whatever carrier they land
// with; carrier movement is a separate fact on the term. Re-up = retained
// after a lapse. First = new to the agency. Unlinked = predecessor unknown.
// One list; the deal header and the terms chain both read it.
export const KIND_LABELS = { renewal: 'Renewal', reup: 'Re-up', rewrite: 'Rewrite', first: 'First', unlinked: 'Unlinked' };

export function lineageLine(t, byId) {
  if (!t) return null;
  const parts = [];
  if (t.ordinal) parts.push(`Term ${t.ordinal}`);
  if (t.kind && KIND_LABELS[t.kind]) parts.push(KIND_LABELS[t.kind]);
  else if (t.lineage_unavailable) parts.push('lineage unavailable');
  const prior = t.follows ? (byId?.get?.(String(t.follows)) || null) : null;
  if (t.follows) parts.push(`followed ${prior ? (prior.carrier || 'prior term') + (prior.policy_end ? ' ' + String(prior.policy_end).slice(0, 4) : '') : 'a term not on this account'}`);
  if (t.carrier_moved_from) parts.push(`moved ${t.carrier_moved_from} → ${t.carrier}`);
  return parts.length ? parts.join(' · ') : null;
}
